module.exports = __webpack_public_path__ + "static/floor2-36cbe64bee5b31ac730350a0cbdc393b.jpg";